import { render, staticRenderFns } from "./DeckItem.vue?vue&type=template&id=7491730f"
import script from "./DeckItem.vue?vue&type=script&lang=ts"
export * from "./DeckItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports